import { SvgIcon, SvgIconProps } from "@mui/material";

interface DoneIconProps extends SvgIconProps {
  fillColorPath?: string;
}

const DoneIcon = ({ fillColorPath = "#E6E8EA", ...props }: DoneIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00109 16.2001L5.50109 12.7001C5.11109 12.3101 4.49109 12.3101 4.10109 12.7001C3.71109 13.0901 3.71109 13.7101 4.10109 14.1001L8.29109 18.2901C8.68109 18.6801 9.31109 18.6801 9.70109 18.2901L20.3011 7.70007C20.6911 7.31007 20.6911 6.69007 20.3011 6.30007C19.9111 5.91007 19.2911 5.91007 18.9011 6.30007L9.00109 16.2001Z"
        fill={fillColorPath}
      ></path>
    </SvgIcon>
  );
};

export default DoneIcon;
